"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PUBLIC_KEY = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.DEFAULT_PUBLIC_KEY = new web3_js_1.PublicKey("11111111111111111111111111111111");
//# sourceMappingURL=types.js.map